document.addEventListener('DOMContentLoaded', function() {
  function removeUnwantedSocialBlocks() {
    const footer = document.querySelector('.footer');
    if (!footer) return;
    const appBlocks = footer.querySelectorAll('.footer__block--app');
    
    appBlocks.forEach(function(block) {
      const hasDesktopClass = block.querySelector('.rrss-desktop-only') !== null;
      const hasMobileClass = block.querySelector('.rrss-mobile-only') !== null;

      if (!hasDesktopClass && !hasMobileClass) {
        block.remove();
      }
    });
  }

  removeUnwantedSocialBlocks();
  setTimeout(removeUnwantedSocialBlocks, 500);

  window.addEventListener('load', removeUnwantedSocialBlocks);
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        removeUnwantedSocialBlocks();
      }
    });
  });

  const footer = document.querySelector('.footer');
  if (footer) {
    observer.observe(footer, { childList: true, subtree: true });
  }
});